import styled from 'styled-components';

import { Heading2 } from 'packages/smart-home-support/components/Typography';

export default styled(Heading2)`
  text-align: center;
  margin-bottom: 10px;
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/CalculatorResultsHeader.tsx